import React, { useEffect } from "react";
import moment from "moment";
import SoftBadge from "modules/common/SoftBadge";

function PrescriptionForm({ customer, setStage, setAge, setSyntheticId }) {
  const questionId = ["2e", "hair_vol1"];
  const ageId = ["C1d"];
  const question = [
    "utm_campaign",
    "utm_medium",
    "utm_source",
    "How old are you?",
    "cohort",
  ];

  useEffect(() => {
    const sortedData = sortData(customer?.responses);
    let firstEntrySyntheticID = null;
    const keys = Object.keys(sortedData);
    for (const key of keys) {
      if (sortedData[key].length > 0) {
        firstEntrySyntheticID = sortedData[key][0].synthetic_id;
        setSyntheticId(firstEntrySyntheticID);
        break; // Break after getting the first entry's synthetic ID
      }
    }
  }, [customer]);

  function sortData(responses) {
    const data = responses
      .sort((responseA, responseB) => {
        return (
          new Date(responseA?.created_at) - new Date(responseB?.created_at)
        );
      })
      .reduce((acc, response) => {
        const synId = response?.synthetic_id;
        acc[synId] = acc[synId] || [];
        acc[synId].push({
          displayDate: moment(response.updated_at).format(
            "MMM Do YYYY, h:mm a"
          ),
          ...response,
        });
        return acc;
      }, {});

    const sortedData = Object.values(data).reduce((acc, entry) => {
      const date = entry[0].displayDate;
      acc[date] = entry;
      return acc;
    }, {});
    return sortedData;
  }

  const dataLength = Object.values(sortData(customer?.responses))?.length - 1;

  return (
    <div className="side-sub-ab scrollable-container  shadow rounded">
      <div className="fw-bold text-center">
        {customer &&
        customer?.responses &&
        Object.values(sortData(customer?.responses))[dataLength] &&
        Object.values(sortData(customer?.responses))[dataLength][0] ? (
          <div className="d-flex align-items-center border border-2 rounded-top py-1 justify-content-center">
            <span className="fw-bold">Form Filled Date: </span>
            <span style={{ fontSize: "1.1rem" }}>
              <SoftBadge bg="info" className="me-2 ms-2">
                {Object.values(sortData(customer.responses))[dataLength][0]
                  .displayDate || "Form Data"}
              </SoftBadge>
            </span>
          </div>
        ) : (
          <span>Data not available</span>
        )}
      </div>
      <div
        style={{
          maxHeight: "37rem",
          minHeight: "15rem",
          overflowY: "scroll",
        }}
        className="mt-1 scrollable-container  prescription-grid-container"
      >
        {Object.values(sortData(customer?.responses))[dataLength]?.map(
          (responses) => {
            if (questionId.includes(responses?.question_id)) {
              setStage(responses?.response);
            }
            if (ageId.includes(responses?.question_id)) {
              setAge(responses?.response);
            }
            if (question.includes(responses?.question)) {
              return;
            }
            return (
              <div key={responses?.id} className="border rounded shadow my-1">
                <div className="m-0 p-2 border-bottom text-break text-wrap">
                  {responses?.question}
                </div>
                <div className="m-0 p-2 text-success text-break text-wrap">
                  {responses?.response}
                </div>
              </div>
            );
          }
        )}
      </div>
    </div>
  );
}

export default PrescriptionForm;
